import { render, staticRenderFns } from "./CourseName.vue?vue&type=template&id=4afc688a&scoped=true&"
import script from "./CourseName.vue?vue&type=script&lang=js&"
export * from "./CourseName.vue?vue&type=script&lang=js&"
import style0 from "./CourseName.vue?vue&type=style&index=0&id=4afc688a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc688a",
  null
  
)

export default component.exports